
import { AvatarImage, Pagination } from "components";
import AvatarCharecter from "components/ui-common/AvatarCharecter";
import { useApp, usePermission, useTask } from "hooks";
import { Calendar, MoreHorizontal, X } from "lucide-react";
import React, { useCallback, useEffect, useState } from "react";
import { formatBytes, formatDMYInd, hexToRgba, priorityColors, repareStorageURL, repareURL, taskLabels } from "utils";
import { taskActions } from "utils";
import Zoom from 'react-medium-image-zoom';
import { ETaskActions } from "types";
import Comments from "../comments/Comments";

const TaskList = ({ dataTasks = null, onAction, projectId, currentPage, isFetch = 1 }) => {
  const { totalPage, data: listData } = dataTasks;
  const { can, isAdmin } = usePermission()
  const [showActions, setShowActions] = useState(false);

  const [selectedTask, setSelectedTask] = useState(null);

  const { fetchDataDetail } = useTask();
  const { onUpdateParams, taskDetail, taskFilter } = useApp();
  const { data: dataDetail } = fetchDataDetail(projectId, selectedTask?.id, isFetch)

  useEffect(() => {
    if (dataDetail?.data) {
      setSelectedTask(dataDetail.data);
      onUpdateParams({ taskDetail: dataDetail.data })
    }
  }, [dataDetail?.data])

  const filteredTasks = listData.filter(task => {
    // const matchesSearch = task.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   task.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = taskFilter.status === 'all' || task.status === taskFilter.status;//taskFilter.status === 'all' ||  || task.priority === taskFilter.priority;
    return matchesFilter && task.type === 'task';
  });

  const handleActions = (act: string, opts: any = {}) => {
    setShowActions(false);
    const isActions = [`${ETaskActions.DELETE}`, `${ETaskActions.CLOSED}`, `${ETaskActions.OPEN}`]
    console.log("🚀 ~ handleActions ~ taskDetail?.status === 100 && act !== ETaskActions.CLOSE:", taskDetail?.progress === 100, !isActions.includes(act), !isAdmin)
    if (taskDetail?.progress === 100 && !isActions.includes(act) && !isAdmin) return;
    if (act === ETaskActions.CLOSED || act === ETaskActions.OPEN) {
      opts = {
        project_id: projectId,
        id: taskDetail.id,
        status: act
      }
    }
    onAction?.(act, opts);//attachment
  }

  const onClose = () => {
    setSelectedTask(null);
    setShowActions(false)
    onUpdateParams({ taskDetail: null })
  }

  const ListView = () => (
    <div className=" w-full">
      {!!listData?.length && <div className="bg-white rounded-lg shadow-sm border border-gray-200 w-full">
        <div className="grid grid-cols-12 gap-4 p-4 border-b border-gray-200 font-semibold text-sm text-gray-600">
          <div className="col-span-3">Nhiệm vụ</div>
          <div className="col-span-2">Giao cho</div>
          <div className="col-span-1">Trạng thái</div>
          <div className="col-span-1">Ngày hết hạn</div>
          <div className="col-span-1">Độ ưu tiên</div>
          <div className="col-span-2">Thẻ</div>
          <div className="col-span-2">Tiến độ </div>
        </div>
        {filteredTasks.map(task => (
          <div key={task.id} className="grid grid-cols-12 gap-4 p-4 border-b border-gray-200 hover:bg-gray-50 cursor-pointer"
            onClick={() => setSelectedTask(task)}>
            <div className="col-span-3">
              <h3 className="font-medium text-gray-900">{task.title}</h3>
              <p className="text-sm text-gray-600">{task.description}</p>
            </div>
            <div className="col-span-2 flex items-center space-x-2">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white text-sm">
                {task.assignee?.avatar ?
                  <AvatarImage className="w-8 h-8 rounded-full" src={repareURL(task.assignee?.avatar)} alt={task.assignee?.name} /> : <AvatarCharecter className="w-8 h-8" name={task.assignee?.name} />}
              </div>
              <span className="text-sm">{task.assignee?.name}</span>
            </div>
            <div className="col-span-1 flex flex-row items-center gap-2">
              <span className={`px-3 py-1 text-xs ${taskLabels[task.status]} rounded-full`}>
                {task.status}
              </span>
            </div>
            <div className="col-span-1 flex items-center space-x-1 text-sm text-gray-600">
              {task.due_date && <div className="flex flex-row items-center gap-2">
                <Calendar size={14} />
                <span>{formatDMYInd(task.due_date, '-')}</span>
              </div>}
            </div>
            <div className="col-span-1 flex flex-row items-center gap-2">
              <span className={`px-2 py-1 rounded-full text-xs ${priorityColors[task.priority]}`}>
                {task.priority}
              </span>
            </div>
            <div className="col-span-1 flex flex-row items-center gap-2">
              {!!task.tags.length && task.tags.map(tag => <span key={`taglist-${tag.id}`}
                style={{ backgroundColor: hexToRgba(`${tag.color}`, 0.2), color: `${tag.color}` }}
                className={`px-2 py-1 rounded-full font-semibold text-xs`}>
                {tag.name}
              </span>)}
            </div>
            <div className="col-span-2 flex items-center space-x-2">
              <div className="flex-1 bg-gray-200 rounded-full h-2">
                <div
                  className="bg-blue-500 h-2 rounded-full transition-all duration-300"
                  style={{ width: `${task.progress}%` }}
                />
              </div>
              <span className="text-sm text-gray-600">{task.progress}%</span>
            </div>
          </div>
        ))}
      </div>}
      <div className="mt-10">
        {totalPage > 1 && <Pagination onPageChange={(page) => handleActions(ETaskActions.PAGINATE, { page })} currentPage={currentPage} totalPages={totalPage} />}
      </div>
    </div>
  );

  const renderMenuActions = (status = '') => (<div className="absolute right-4 top-12">
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-2 text-sm">
      {taskActions.map(e => {
        if (!can(e.action, "task")) return null;
        return e.action !== status ? (
          <div onClick={() => handleActions(e.action)} key={e.action} className="flex items-center space-x-2 p-2 hover:bg-gray-50 cursor-pointer">
            {e.icon}
            <span>{e.name}</span>
          </div>
        ) : null;
      })}
    </div>
  </div>);
  // console.log("🚀 ~ taskDetail?.tags.length :", taskDetail?.tags.length)
  const renderSelectedTask = useCallback(() => {
    return (
      <div className="w-full bg-white rounded-lg shadow-sm border border-gray-200 flex flex-col max-h-screen relative">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200" >
          <div className="flex items-center space-x-3">
            {/* <button className="text-gray-400 hover:text-gray-600">
                    <Circle size={20} />
                  </button>
                  <span className="text-sm text-gray-500">Mark as completed</span> */}
          </div>
          <div className="flex items-center space-x-2 relative z-10">
            <button onClick={() => setShowActions(s => !s)} className="text-gray-400 hover:text-gray-600">
              <MoreHorizontal size={20} />
            </button>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <X size={20} />
            </button>
          </div>
        </div>
        {/* Action Menu */}
        {showActions && renderMenuActions(taskDetail.status)}
        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4 ">

          <div className="space-y-6">
            {/* Task Title */}
            <div>
              <div className="flex justify-between">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {taskDetail?.title}
                  <div className="my-4 col-span-2 flex flex-row items-center gap-2">
                    <span className={`px-3 py-1 text-xs ${taskLabels[taskDetail.status]} rounded-full`}>
                      {taskDetail.status}
                    </span>
                  </div>
                </h3>
              </div>

              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-3">
                  <span className="text-sm text-gray-500">Giao cho: </span>
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center text-white text-xs">
                      {taskDetail?.assignee?.avatar ?
                        <AvatarImage className="w-6 h-6 rounded-full" src={repareURL(taskDetail?.assignee?.avatar)} alt={taskDetail?.assignee?.name} /> : <AvatarCharecter name={taskDetail?.assignee?.name} />}
                    </div>
                    <span className="text-sm font-medium">{taskDetail?.assignee?.name}</span>
                  </div>
                </div>
                {taskDetail?.due_date && <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-500">Ngày đến hạn</span>
                  <div className="flex flex-row items-center space-x-1 text-sm">
                    <Calendar size={14} className="text-green-500" />
                    <span className="font-medium">{formatDMYInd(taskDetail?.due_date, '-')}</span>
                  </div>
                </div>}
              </div>
            </div>

            {/* Description */}
            {taskDetail?.content && <div className="bg-gray-50 rounded-lg p-4">
              <div dangerouslySetInnerHTML={{ __html: taskDetail?.content }}></div>
            </div>}
            {taskDetail?.tags.length && <div className="mb-2">Nhãn:
              {taskDetail?.tags.map(tag => (<span style={{ backgroundColor: hexToRgba(`${tag.color}`, 0.2), color: `${tag.color}` }} key={`tag-${tag.id}`} className={`font-semibold ml-2 px-2 py-1 rounded-full text-xs`}>
                {tag.name}
              </span>))}
            </div>}
            {/* Checklists/Sub-tasks */}
            {/* <div>
              <h4 className="font-medium text-gray-900 mb-3">Checklists/Sub-tasks</h4>
              <div className="space-y-2">
                <div className="flex items-center space-x-3">
                  <input type="checkbox" className="rounded" />
                  <span className="text-sm text-gray-700">Find out the old contract documents</span>
                </div>
                <div className="flex items-center space-x-3">
                  <input type="checkbox" className="rounded" />
                  <span className="text-sm text-gray-700">Organize meeting sales associates to understand need in detail</span>
                </div>
                <div className="flex items-center space-x-3">
                  <input type="checkbox" className="rounded" />
                  <span className="text-sm text-gray-700">Make sure to cover every small details</span>
                </div>
              </div>
            </div> */}

            {/* Attachments */}
            {!!taskDetail?.files?.length && <div>
              <h4 className="font-medium text-gray-900 mb-3">Hình ảnh</h4>

              <div className="space-y-2">
                {taskDetail?.files.map(file => (
                  <div key={file.id} className="flex items-center justify-between p-2 bg-blue-50 rounded-lg">
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 bg-blue-500 rounded flex items-center justify-center text-white text-xs font-medium">
                        <Zoom>
                          <img className="max-w-10 p-1 rounded-md" src={repareStorageURL(`${file?.path}`)} alt={file.name} />
                        </Zoom>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-900">{file.name}</p>
                        <p className="text-xs text-gray-500">{formatBytes(file.size)}</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2">
                      <button onClick={() => handleActions(ETaskActions.DETACH, { path: file?.path })} className="text-red-400 hover:text-red-600">
                        <X size={16} />
                      </button>
                    </div>

                  </div>
                ))}
              </div>
            </div>}

            {/* Comments */}
            <Comments projectId={projectId} taskId={taskDetail?.id} />
            {/* <MentionCommentSystem /> */}
          </div>
        </div>
      </div>
    )
  }, [taskDetail, showActions])

  return (
    <div className="min-h-screen bg-gray-50">

      <div className="mx-auto">
        <div className="flex gap-6" >
          <ListView />
          {taskDetail && renderSelectedTask()}
        </div>
      </div>
    </div>
  );
};

export default TaskList;